import { isLocal, isProd } from '../config'

export const getApiKey = () => {
  if (isProd) return 'PdatTPGdti5BnowHQzsIS416Qr3XnDGW7IS7UmxW'
  if (isLocal && process.env.REACT_APP_USE_LOCAL_API) return 'd41d8cd98f00b204e9800998ecf8427e'
  return 'OBPahnEebI1eEP62ecY7BH34j16Vve2aq1F7lDL2'
}
